import Alerts from './Alerts';
import Configurator from "./Configurator";
import Sites from './Sites';
import Organizations from './Organizations';
import Dashboard from './Dashboard';

export default {
    Alerts, Configurator, Sites, Organizations, Dashboard
};